/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Outbound sync request
 * @export
 * @interface OutboundSyncRequest
 */
export interface OutboundSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof OutboundSyncRequest
     */
    entityType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutboundSyncRequest
     */
    entityIds?: Array<string>;
}

/**
 * Check if a given object implements the OutboundSyncRequest interface.
 */
export function instanceOfOutboundSyncRequest(value: object): value is OutboundSyncRequest {
    return true;
}

export function OutboundSyncRequestFromJSON(json: any): OutboundSyncRequest {
    return OutboundSyncRequestFromJSONTyped(json, false);
}

export function OutboundSyncRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundSyncRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityIds': json['entityIds'] == null ? undefined : json['entityIds'],
    };
}

export function OutboundSyncRequestToJSON(json: any): OutboundSyncRequest {
    return OutboundSyncRequestToJSONTyped(json, false);
}

export function OutboundSyncRequestToJSONTyped(value?: OutboundSyncRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': value['entityType'],
        'entityIds': value['entityIds'],
    };
}

